import CourseDetailLayout from '../components/CourseDetailLayout'
import { getSchedule } from '../components/ScheduleTable'
import { useTranslation } from 'react-i18next'
import balletMobile01 from '../assets/courses/mobile/ballet-01.jpg'
import balletMobile02 from '../assets/courses/mobile/ballet-02.jpg'
import balletMobile03 from '../assets/courses/mobile/ballet-03.jpg'
import balletDesktop01 from '../assets/courses/desktop/ballet-01.jpg'
import balletDesktop02 from '../assets/courses/desktop/ballet-02.jpg'
import balletDesktop03 from '../assets/courses/desktop/ballet-03.jpg'

const mobilePics = [balletMobile01, balletMobile02, balletMobile03]
const desktopPics = [balletDesktop01, balletDesktop02, balletDesktop03]

const classes = getSchedule('schedule.classicBallet')

const BalletPage = () => {
  const { t } = useTranslation()

  return (
    <CourseDetailLayout
      title={t('nav.classic')}
      images={mobilePics}
      desktopImages={desktopPics}
      content={[t('courses.balletDescription'), t('courses.balletDetails')]}
      classes={classes}
    />
  )
}

export default BalletPage
